package horcrux.common.api.dtos.types

import horcrux.common.HorcruxEither
import horcrux.common.URLValueClass
import horcrux.common.configs.DocumentStorageConfigs
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

interface DocumentInput {
    val defaultDocumentName: DocumentName
}

@Serializable
@JvmInline
value class DocumentURL(override val value: String) : URLValueClass<DocumentURL>, DocumentInput {
    override val defaultDocumentName: DocumentName
        get() = DocumentName(value)

    fun isCloudStorageURL(): Boolean = value.startsWith(DocumentStorageConfigs.AUTHENTICATED_URL_BASE)

    override fun toString(): String = "DocumentURL<***>"

    companion object {
        fun create(url: String): HorcruxEither<DocumentURL> = DocumentURL(url).validate()
    }
}
